import { Box, Heading, Text, VStack } from "native-base";
import React from "react";
import PropTypes from "prop-types";
import Modal from "../modal";
import { Link } from "react-router-dom";
import routes from "../../routes";
import colors from "../../constants/colors";

function QuotationFinishedModal(props) {
  const { isOpen, role } = props;

  if (!isOpen) {
    return null;
  }

  return (
    <Modal maxWidth={700} isOpen>
      <VStack paddingX={10} paddingY={8} space={10} alignItems="center">
        <Heading fontSize="2xl" color={colors.secondary}>
          ¡Felicidades!
        </Heading>
        <Text color={colors.secondary} textAlign="center" fontSize="lg">
          Tu tour ha sido creado con éxito. Sin embargo, recuerda que una vez
          creado, no podrás editarlo. Si necesitas cambios importantes, utiliza
          el botón de ayuda ubicado en la esquina inferior derecha de la
          pantalla.
        </Text>
        <Text color={colors.secondary} textAlign="center" fontSize="lg">
          ¡Gracias por usar nuestra aplicación!
        </Text>
        <Link
          to={
            role === "agency" ? routes.agencyPaymentManagement : routes.trips
          }>
          <Box
            backgroundColor={colors.primary}
            paddingY={3}
            paddingX={100}
            borderRadius="full">
            <Text color={colors.white}>Continuar</Text>
          </Box>
        </Link>
      </VStack>
    </Modal>
  );
}

QuotationFinishedModal.propTypes = {
  isOpen: PropTypes.bool,
  role: PropTypes.string,
};

QuotationFinishedModal.defaultProps = {
  isOpen: false,
  role: "agency",
};

export default React.memo(QuotationFinishedModal);
